module.exports = __webpack_public_path__ + "static/media/cheese_hero.90bf32b9.jpg";